import { ButtonPosition } from '@/common/manager/position/button-position';
import cloneDeep from 'lodash/cloneDeep';
import isPlainObject from 'lodash/isPlainObject';
import { getArrayTableCurrentRowByField2, getRealizeValue, isArrayNotEmpty, } from '@/common/util/util';
import { handleRequestParams } from '@/common/util/request';
import { __arrayTableCurrentRow__, componentRefSplit, } from '@/common/util/expr-const';
import { formComponentRefStorage } from '@/common/util/const';
export const config = {
    value: 'setSelectDataSource',
    position: [
        ButtonPosition.formItemEvent,
        ButtonPosition.formDialogItemEvent,
        ButtonPosition.cnArrayTableItemEvent,
        ButtonPosition.filterItemEvent,
    ],
    action: (arg) => {
        const { buttonConfig, formInstance, urlParamsDataSource, recordDataSource, state, componentProps, field, } = arg || {};
        const { options } = buttonConfig || {};
        const { toSetDataSourceList } = options || {};
        const realFormInstance = getRealizeValue(formInstance);
        if (realFormInstance) {
            if (Array.isArray(toSetDataSourceList) &&
                toSetDataSourceList.length > 0) {
                const temp = handleRequestParams(toSetDataSourceList, {
                    urlParamsDataSource,
                    recordDataSource: getRealizeValue(recordDataSource),
                    state,
                    extraParamList: [
                        {
                            __arrayTableCurrentRow__: getArrayTableCurrentRowByField2(field) || {},
                        },
                    ],
                });
                if (isPlainObject(temp)) {
                    const newValue = cloneDeep(temp);
                    for (const key in newValue) {
                        if (key) {
                            let newDataSource = newValue[key];
                            if (!Array.isArray(newDataSource)) {
                                newDataSource = [];
                            }
                            let newKey = key;
                            let newIndex;
                            if (key.includes(__arrayTableCurrentRow__)) {
                                const segments = field?.path?.segments;
                                if (isArrayNotEmpty(segments)) {
                                    newIndex = +segments[segments.length - 2];
                                }
                                newKey = key.replace(__arrayTableCurrentRow__, newIndex);
                            }
                            const { _dataSourceName } = componentProps || {};
                            if (_dataSourceName) {
                                const selectRef = formComponentRefStorage[`${_dataSourceName}${componentRefSplit}${newKey}`];
                                if (typeof selectRef?.current?.mutateDataSource === 'function') {
                                    selectRef?.current?.mutateDataSource(newDataSource);
                                }
                            }
                        }
                    }
                }
            }
        }
    },
};
